export default {
    export: 'Export',
    'print-material-statement': 'Print item statement',
    'export-as-excel':'Export as excel file',
    'material-name-or-num': 'Item ID or name',
    'from-date': 'Start date',
    'to-date': 'End date',
    'refresh': 'Refresh',
    'go-to-the-journal-entry': 'Go to the journal entry',
    'final-balance': 'Final balance:',
    'total-incoming-quantity': 'Total incoming quantity',
    'total-outcoming-quantity': 'Total outcoming quantity',
    'delivery-statuses' : 'Delivery Statuses',
    'show-material-status-footer': 'Show Material Status',

    headers: {
        'balance': 'Balance',
        'income-quantity': 'Incoming quantity',
        'outcome-quantity': 'Outcoming quantity',
        'count': 'Count',
        'note': 'Note',
        'date': 'Date',
        'price': 'Price',
        'document-no': 'Ref. Doc.',
        'materials-journal-balance': 'Item journal No.',
        'invoice-balance': 'Invoice No.',
        'sequence': 'Serial',
        'account': 'Account',
        'child-material': 'Child Material',
        'delivery-status': 'Delivery Status'
    }
}